module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.12395/images/product-background.png"